import BodySimpleModal from '../common/modal/BodySimpleModal'
import BodySimpleModalHTML from '../common/modal/BodySimpleModalHTML'
import classes from './HoverWrapperInfo.module.css'

export default function HoverWrapperInfo({children, modalText, htmlText}) {
    return <div className={`${classes.wrapper}`} >
        {children}
        {!htmlText && <BodySimpleModal normalEvent={true} messages={[modalText]} htmlText={htmlText}/>}
        {htmlText && <BodySimpleModalHTML normalEvent={true} messages={modalText} htmlText={htmlText}/>}
    </div>
}